import React, { useCallback } from 'react';
import { addToast } from '@heroui/react';
import { useTranslation } from 'react-i18next';
import { DashboardTab } from '@/components/admin/dashboard';
import { useAnalyticsSummary, useInvalidateAnalyticsCache } from '@/hooks/queries/useAnalytics';

const DashboardContainer: React.FC = () => {
  const { t } = useTranslation('admin');
  const { data, isLoading, refetch, isRefetching } = useAnalyticsSummary();
  const invalidateCacheMutation = useInvalidateAnalyticsCache();

  const handleRefresh = useCallback(async () => {
    try {
      await invalidateCacheMutation.mutateAsync();
      await refetch();
      addToast({
        title: t('dashboard.refreshSuccess'),
        color: 'success',
      });
    } catch (error) {
      addToast({
        title: t('dashboard.refreshError'),
        color: 'danger',
      });
    }
  }, [invalidateCacheMutation, refetch, t]);

  return (
    <DashboardTab
      data={data}
      isLoading={isLoading}
      isRefreshing={isRefetching || invalidateCacheMutation.isPending}
      onRefresh={handleRefresh}
    />
  );
};

export default DashboardContainer;

